import React from 'react';
import {
  Snackbar as MuiSnackbar,
  SnackbarProps as MuiSnackbarProps,
  SnackbarOrigin,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Alert as MuiAlert } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { Typography } from '@HomaHealth/ui-component-library';

export interface SnackbarProps extends SnackbarOrigin, MuiSnackbarProps {
  open: boolean;
  handleClose?: () => void;
  severity?: MuiColor;
  duration?: number | null;
  width?: string;
}

const Snackbar: React.FC<SnackbarProps> = ({
  open,
  vertical,
  horizontal,
  handleClose,
  message,
  severity,
  duration,
  width,
  ...props
}) => {
  const useStyles = makeStyles()(() => ({
    snackbar: {
      whiteSpace: 'pre-line',
      height: 'auto',
      lineHeight: '28px',
      maxWidth: width ?? '32%',
    },
    alert: {
      alignItems: 'center',
    },
  }));
  const { classes } = useStyles();
  return (
    <MuiSnackbar
      className={classes.snackbar}
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={handleClose}
      key={vertical + horizontal}
      autoHideDuration={duration}
      {...props}
    >
      <MuiAlert
        onClose={handleClose}
        severity={severity}
        className={classes.alert}
      >
        <Typography>{message}</Typography>
      </MuiAlert>
    </MuiSnackbar>
  );
};
export default Snackbar;
